module.exports = __webpack_public_path__ + "img/bitcoin_select.cbe72795.png";